const BaseUrl = '/service/';
const Title = 'IACAS ESI';
const WsUrl = 'wss://iacas.edifly-dev.com/ws'
const BaseColor = '#158550';

module.exports = {
    BaseUrl,
    Title,
    WsUrl,
    BaseColor
}